import { v4 } from 'uuid';
import { UUID } from 'v2/core/entities/uuid';
import Conjunction from 'v2/querybuilder/types/conjunction';
import { NormalisedFilterGroup } from 'v2/querybuilder/types/querystore';

interface getNewFilterGroupNodeParams {
  parentID?: UUID;
  conjunction: Conjunction;
  children?: UUID[];
}

export function getNewFilterGroupNode({
  parentID,
  children,
  conjunction,
}: getNewFilterGroupNodeParams): NormalisedFilterGroup {
  return {
    id: v4(),
    type: 'group',
    parent: parentID,
    children: children ?? [],
    conjunction,
  };
}
